import { stylesheet } from "typestyle";

const styles = stylesheet({
  container: {
    overflowX: "auto",
  },
});

export default styles;
